'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

var IrisPropTypes = _interopRequireWildcard(_irisPropTypes);

var _uiImage = require('@spp/ui-image');

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _uiExternalLink = require('@spp/ui-external-link');

var _uiExternalLink2 = _interopRequireDefault(_uiExternalLink);

var _themeProvider = require('@spp/theme-provider');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeaserInternalLink = (0, _themeProvider.themer)('@spp/ui-teaser-small')(_uiInternalLink2.default);
var TeaserExternalLink = (0, _themeProvider.themer)('@spp/ui-teaser-small')(_uiExternalLink2.default);

var Teaser = function Teaser(_ref) {
    var _ref$image = _ref.image;
    _ref$image = _ref$image === undefined ? {} : _ref$image;
    var imageAsset = _ref$image.imageAsset,
        imagePosition = _ref.imagePosition,
        _ref$label = _ref.label,
        label = _ref$label === undefined ? {} : _ref$label,
        _ref$target = _ref.target,
        uri = _ref$target.uri,
        expandedUri = _ref$target.expandedUri,
        type = _ref$target.type,
        title = _ref.title,
        theme = _ref.theme,
        sizes = _ref.sizes,
        stylizr = _ref.stylizr;

    var rootClasses = (0, _classnames3.default)(theme.root, (0, _defineProperty3.default)({}, theme.alternateImagePosition, imagePosition !== 'left'));

    var teaserImage = void 0;
    if (imageAsset) {
        teaserImage = _react2.default.createElement(
            'div',
            { className: theme.image },
            _react2.default.createElement(_uiImage.ImageAsset, (0, _extends3.default)({}, imageAsset, { sizes: sizes, testTag: '@spp/ui-teaser-small:image-asset' }))
        );
    }
    var labelElement = void 0;
    if (label.value) {
        labelElement = _react2.default.createElement(
            'div',
            { className: theme.label },
            stylizr(label.value, label.markup)
        );
    }

    var contentElement = _react2.default.createElement(
        'div',
        { className: theme.content },
        labelElement,
        _react2.default.createElement(
            'h3',
            { className: theme.title },
            stylizr(title.value, title.markup)
        )
    );

    if (type === 'link:internal') {
        return _react2.default.createElement(
            TeaserInternalLink,
            { link: expandedUri || uri, className: rootClasses, testTagDefault: '@spp/ui-teaser-small:link-internal', testTagSinglePage: '@spp/ui-teaser-small:link-internal', enableSinglePage: true },
            teaserImage,
            contentElement
        );
    }

    return _react2.default.createElement(
        TeaserExternalLink,
        { href: expandedUri || uri, className: rootClasses, testTagDefault: '@spp/ui-teaser-small:link-external' },
        teaserImage,
        contentElement
    );
};

Teaser.defaultProps = {
    image: undefined,
    imagePosition: 'left',
    target: {},
    type: 'link:internal',
    theme: {},
    label: undefined,
    expandedUri: {},
    sizes: '(min-width: 800px) 100px, 30vw',
    stylizr: function stylizr(text) {
        return text;
    }
};

Teaser.propTypes = {
    title: IrisPropTypes.objects.text.isRequired,
    label: IrisPropTypes.objects.text,
    image: IrisPropTypes.components.imageComponent,
    imagePosition: _propTypes2.default.string,
    sizes: _propTypes2.default.string,
    stylizr: _propTypes2.default.func,
    target: _propTypes2.default.shape({
        expandedUri: _propTypes2.default.string,
        uri: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string
    }).isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        alternateImagePosition: _propTypes2.default.string,
        image: _propTypes2.default.string,
        content: _propTypes2.default.string,
        title: _propTypes2.default.string,
        label: _propTypes2.default.string
    })
};

exports.default = Teaser;
//# sourceMappingURL=Teaser.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-teaser-small/lib/cjs/Teaser.js
 ** module id = 528
 ** module chunks = 1
 **/